// ** Initial State
const initialState = {
  allData: [],
  booking: null,
  pricing: [],
  notes: null
}

const booking3 = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
   
    case 'GET_BOOKING':
      return { ...state, booking: action.data }

    case 'GET_ALL_PRICING':
      return { ...state, pricing: action.data }

    case 'CREATE_BOOKING_NOTES':
      return { ...state, notes: action.data }

    default:
      return { ...state }
  }
}
export default booking3
